import { ICSSInJSStyle } from "@fluentui/react-northstar";
import { useState, useEffect } from "react";

import { useFluentColorScheme } from "../../../shared/theme/useColorScheme";
import { useDeviceTesterStateContext } from "../../device-tester-context-provider/DeviceTesterContextProvider";
interface ResultsStartAudioTestButton {
  testCallButton: ICSSInJSStyle;
}

export const useResultsStartAudioTestButton: () => ResultsStartAudioTestButton =
  () => {
    const { brand, main } = useFluentColorScheme();
    const { deviceTesterState } = useDeviceTesterStateContext();

    const [infoFetched, setInfoFetched] = useState(
      deviceTesterState.isInfoFetched
    );

    useEffect(() => {
      setInfoFetched(deviceTesterState.isInfoFetched);
    }, [deviceTesterState.isInfoFetched]);

    return {
      testCallButton: {
        backgroundColor: "transparent",
        color: infoFetched ? brand.foreground2 : main.foregroundDisabled,
        border: `1px solid ${
          infoFetched ? brand.border2 : main.foregroundDisabled
        }`,
        borderRadius: "5px",
        padding: "0px 8px",
        width: "189px",
        height: "32px",
      },
    };
  };
